import { DOMAINS_LIST_ACTION, ADD_DOMAIN_ACTION, UPDATE_DOOMAIN_ACTION, domainsList } from "../Actions/DomainsListAction";

const initialstate = { domainsList: [] };

const DomainsListReducer = (state = initialstate, action) => {
    switch (action.type) {
        case DOMAINS_LIST_ACTION:
            return {
                ...state,
                domainsList: action.payload,
            };
        case ADD_DOMAIN_ACTION:
            return {
                ...state,
                domainsList: [...state.domainsList, action.payload],  
            };
        case UPDATE_DOOMAIN_ACTION:
            return {
                ...state,
                domainsList: state.domainsList.map(domain =>
                    domain.id === action.payload.id
                        ? { ...action.payload } 
                        : domain
                ),
            };


        default:
            return state
    }
}


export default DomainsListReducer;


